import { EnumEntriesLetterPlaceholderItem } from '../api/generated/model';

export function getLetterPlaceholderName(placeholder: EnumEntriesLetterPlaceholderItem) {
  switch (placeholder) {
    case EnumEntriesLetterPlaceholderItem.PATIENT_NAME:
      return 'Name und Vorname des Patienten';
    case EnumEntriesLetterPlaceholderItem.PATIENT_BIRTHDAY:
      return 'Geburtsdatum des Patienten';
    case EnumEntriesLetterPlaceholderItem.PATIENT_CASE_NUMBER:
      return 'Fallnummer';
    case EnumEntriesLetterPlaceholderItem.PATIENT_NATIONALITY:
      return 'Nationalität des Patienten';
    case EnumEntriesLetterPlaceholderItem.PATIENT_RESIDENCE_ORGANIZATION:
      return 'Aktueller Wohnort (z.B. Asylzentrum)';
    case EnumEntriesLetterPlaceholderItem.PATIENT_RESIDENCE_STREET:
      return 'Strasse inkl. Nummer des aktuell gültigen Wohnortes';
    case EnumEntriesLetterPlaceholderItem.PATIENT_RESIDENCE_CITY:
      return 'PLZ und Ort des aktuell gültigen Wohnortes';
    case EnumEntriesLetterPlaceholderItem.PATIENT_PHONE:
      return 'Telefonnummer des Patienten';
    case EnumEntriesLetterPlaceholderItem.EMPLOYEE_NAME:
      return 'Name und Vorname des eingeloggten Benutzers';
    case EnumEntriesLetterPlaceholderItem.EMPLOYEE_EMAIL:
      return 'E-Mail-Adresse des eingeloggten Benutzers';
    case EnumEntriesLetterPlaceholderItem.GENERAL_DATE:
      return 'Heutiges Datum';
  }
}
